import { render } from "./TrailingText.vue?vue&type=template&id=da3086be"
import script from "./TrailingText.vue?vue&type=script&lang=js"
export * from "./TrailingText.vue?vue&type=script&lang=js"
script.render = render

export default script